import { AuthStorage } from "utils/auth-storage";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { saveReportAccessLevel } from "redux/permission-reducer";
import { ReportServices } from "apis/Services/ReportService";
import { WarehouseServices } from "apis/Services/WarehouseService";

import { Button, Input, Dropdown, Table, Modal, Select } from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  MoreOutlined,
  PlusOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import LoadingComponent from "components/loading-component";
import toast from "react-hot-toast";
import LockRoundedIcon from "@mui/icons-material/LockRounded";

export default function WarehouseSettings() {
  const { company_id, id } = useParams();
  const [isLoading, setisLoading] = useState(true);
  const [accessLevel, setAccessLevel] = useState();
  const [data, setData] = useState([]);
  const [searchText, setSearchText] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [newName, setNewName] = useState("");
  const [currentType, setCurrentType] = useState("");

  const dispatch = useDispatch();
  const { Option } = Select;

  function getAccessLevel() {
    setisLoading(true);
    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");
    let ReqObj = {
      company: company_id,
      project: id,
      code,
      loginEmail: email,
    };
    WarehouseServices.inventoryPageAccessLevel(ReqObj)
      .then((res) => {
        setAccessLevel(parseInt(res.accessLevel));
        if (parseInt(res?.accessLevel) > 0) {
          // getProjectsAddress()
          getData();
        } else {
          setisLoading(false);
        }
        dispatch(saveReportAccessLevel(res.accessLevel));
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function getData() {
    // setisLoading(true);
    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");
    let ReqObj = {
      company: company_id,
      code,
      loginEmail: email,
    };
    WarehouseServices.getInventorySettings(ReqObj)
      .then((res) => {
        setData(res);
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setTimeout(() => {
          setisLoading(false);
        }, 1000);
      });
  }

  const handleDeleteItem = (record, type) => {
    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");

    let idKey =
      type === "categories"
        ? "categoryID"
        : type === "subcategories"
          ? "subcategoryID"
          : type === "units"
            ? "unitID"
            : "locationID";

    let itemType =
      type === "categories"
        ? "category"
        : type === "subcategories"
          ? "subcategory"
          : type === "units"
            ? "unit"
            : "location";

    let ReqObj = {
      company: company_id,
      code,
      id: record[idKey],
      type: itemType,
      loginEmail: email,
    };
    WarehouseServices.deleteInventorySettings(ReqObj)
      .then((res) => {
        toast.success("Deleted successfully");
        getData();
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something went wrong, please try again.");
      });
  };

  const handleCreateItem = (type, value) => {
    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");

    let ReqObj = {
      company: company_id,
      categories: type === "categories" ? [value.trim()] : [],
      subcategories: type === "subcategories" ? [value.trim()] : [],
      units: type === "units" ? [value.trim()] : [],
      locations: type === "locations" ? [value.trim()] : [],
      code,
      loginEmail: email,
    };
    WarehouseServices.createInventorySettings(ReqObj)
      .then(() => {
        toast.success("Created successfully");
        getData();
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something went wrong, please try again.");
      });
  };

  const handleEditItem = (record, type, value) => {
    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");

    let idKey =
      type === "categories"
        ? "categoryID"
        : type === "subcategories"
          ? "subcategoryID"
          : type === "units"
            ? "unitID"
            : "locationID";

    let itemType =
      type === "categories"
        ? "category"
        : type === "subcategories"
          ? "subcategory"
          : type === "units"
            ? "unit"
            : "location";

    let ReqObj = {
      company: company_id,
      id: record[idKey],
      type: itemType, // "categories" | "units" | "locations"
      newName: value.trim(),
      code,
      loginEmail: email,
    };
    WarehouseServices.updateInventorySettings(ReqObj)
      .then(() => {
        toast.success("Updated successfully");
        getData();
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something went wrong, please try again.");
      });
  };

  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [createType, setCreateType] = useState("categories");
  const [createName, setCreateName] = useState("");

  // confirm create
  const handleCreateModalOk = () => {
    const existingNames =
      data?.settingsDict?.[createType]?.map((item) =>
        item.name.toLowerCase(),
      ) || [];

    if (existingNames.includes(createName.toLowerCase().trim())) {
      toast.error("Name already exists in this list!");
      return;
    }

    if (!createName.trim()) {
      toast.error("Please enter a name");
      return;
    }

    handleCreateItem(createType, createName);
    setIsCreateModalOpen(false);
    setCreateName("");
    setCreateType("categories");
  };

  const handleCreateModalCancel = () => {
    setIsCreateModalOpen(false);
    setCreateName("");
    setCreateType("categories");
  };

  const openEditModal = (record, type) => {
    setEditingItem(record);
    setNewName(record.name);
    setCurrentType(type);
    setIsModalOpen(true);
  };

  // confirm rename
  const handleModalOk = () => {
    const existingNames =
      data?.settingsDict?.[currentType]?.map((item) =>
        item.name.toLowerCase(),
      ) || [];

    if (existingNames.includes(newName.toLowerCase())) {
      toast.error("Name already exists in this list!");
      return;
    }

    handleEditItem(editingItem, currentType, newName);
    setIsModalOpen(false);
    setEditingItem(null);
    setNewName("");
  };

  const handleModalCancel = () => {
    setIsModalOpen(false);
    setEditingItem(null);
    setNewName("");
  };

  useEffect(() => {
    getAccessLevel();
  }, []);

  const { confirm } = Modal;

  const getColumns = (type) => [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: (text) => <p className="m-0 p-0 lh-1">{text}</p>,
    },
    {
      title: "",
      key: "action",
      width: 60,
      render: (_, record) => {
        const items = [
          {
            key: "edit",
            icon: <EditOutlined />,
            label: "Edit",
            onClick: () => openEditModal(record, type),
          },
          {
            key: "delete",
            icon: <DeleteOutlined />,
            label: "Delete",
            danger: true,
            disabled: accessLevel === 2,
            onClick: () => {
              confirm({
                title: "Are you sure you want to delete this item?",
                content: "This action cannot be undone.",
                okText: "Delete",
                okType: "danger",
                cancelText: "Cancel",
                onOk: () => handleDeleteItem(record, type),
              });
            },
          },
        ];
        return (
          <Dropdown
            menu={{ items }}
            trigger={["click"]}
            disabled={accessLevel < 2}
          >
            <Button type="text" shape="circle" icon={<MoreOutlined />} />
          </Dropdown>
        );
      },
    },
  ];

  const getFilteredData = (type) => {
    const items = data?.settingsDict?.[type] || [];
    if (!searchText.trim()) return items;

    return items.filter((item) =>
      item.name.toLowerCase().includes(searchText.toLowerCase()),
    );
  };

  return (
    <div className="bg-white p-4 rounded-3 p-2 d-flex flex-column justify-content-center">
      {isLoading && (
        <div className="row d-flex justify-content-center">
          <LoadingComponent />
        </div>
      )}

      {!isLoading && accessLevel === 0 && (
        <div className="row w-100 d-flex justify-content-center p-5">
          {!isLoading && accessLevel === 0 && (
            <div className="row w-100 d-flex justify-content-center p-5">
              <div className="d-flex flex-column align-items-center text-center gap-3">
                <LockRoundedIcon style={{ fontSize: "5rem", color: "#999" }} />
                <h6 className="mt-2 mb-0 text-muted">
                  You do not have the necessary permissions to access this page.
                </h6>
              </div>
            </div>
          )}
        </div>
      )}

      {!isLoading && accessLevel > 0 && (
        <div style={{ width: "85%" }} className=" align-self-center">
          <div className="row">
            <div>
              <h3 className="fw-bold p-0 m-0">Settings</h3>
              <p className="opacity-75 mt-2 p-0">
                {/* Manage your construction materials and track inventory across
                job sites */}
              </p>
            </div>
          </div>

          <div className=" d-flex flex-column gap-2">
            <div className=" d-flex justify-content-between mb-2 ">
              <Input
                placeholder="Search categories, subcategories, units, or locations..."
                prefix={<SearchOutlined />}
                style={{ width: "420px" }}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
              <Button
                type="primary"
                className=" ms-2"
                size="large"
                disabled={accessLevel < 2}
                onClick={() => setIsCreateModalOpen(true)}
              >
                <PlusOutlined /> Create
              </Button>
            </div>

            <div className=" bg-light bg-opacity-75 p-4 rounded-4">
              <div>
                <div>
                  <div className="d-flex justify-content-between align-items-center w-100 mb-3">
                    <div>
                      <h6 className=" fw-bold">Categories</h6>
                    </div>
                  </div>
                </div>
                <div>
                  <Table
                    columns={getColumns("categories")}
                    showHeader={false}
                    dataSource={getFilteredData("categories")}
                    bordered
                    size="small"
                    className=" fw-bold"
                    scroll={{ x: "max-content", y: 55 * 5 }}
                    pagination={false}
                  />
                </div>
              </div>
            </div>

            <div className=" bg-light bg-opacity-75 p-4 rounded-4">
              <div>
                <div>
                  <div className="d-flex justify-content-between align-items-center w-100 mb-3">
                    <div>
                      <h6 className=" fw-bold">Subcategories</h6>
                    </div>
                  </div>
                </div>
                <div>
                  <Table
                    columns={getColumns("subcategories")}
                    showHeader={false}
                    dataSource={getFilteredData("subcategories")}
                    bordered
                    size="small"
                    className=" fw-bold"
                    scroll={{ x: "max-content", y: 55 * 5 }}
                    pagination={false}
                  />
                </div>
              </div>
            </div>

            <div className=" bg-light bg-opacity-75 p-4 rounded-4">
              <div>
                <div>
                  <div className="d-flex justify-content-between align-items-center w-100 mb-3">
                    <div>
                      <h6 className=" fw-bold">Units</h6>
                    </div>
                  </div>
                </div>
                <div>
                  <Table
                    columns={getColumns("units")}
                    showHeader={false}
                    dataSource={getFilteredData("units")}
                    bordered
                    className=" fw-bold"
                    size="middle"
                    scroll={{ x: "max-content", y: 55 * 5 }}
                    pagination={false}
                  />
                </div>
              </div>
            </div>

            <div className=" bg-light bg-opacity-75 p-4 rounded-4">
              <div>
                <div>
                  <div className="d-flex justify-content-between align-items-center w-100 mb-3">
                    <div>
                      <h6 className=" fw-bold">Locations</h6>
                    </div>
                  </div>
                </div>
                <div>
                  <Table
                    columns={getColumns("locations")}
                    showHeader={false}
                    dataSource={getFilteredData("locations")}
                    bordered
                    className=" fw-bold"
                    size="middle"
                    scroll={{ x: "max-content", y: 55 * 5 }}
                    pagination={false}
                  />
                </div>
              </div>
            </div>
          </div>

          <Modal
            title="Rename Item"
            centered
            open={isModalOpen}
            onOk={handleModalOk}
            onCancel={handleModalCancel}
            width={300}
            okText="Save"
          >
            <Input
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
              placeholder="Enter new name"
            />
          </Modal>

          {/* Create Modal */}
          <Modal
            title="Create Item"
            centered
            open={isCreateModalOpen}
            onOk={handleCreateModalOk}
            onCancel={handleCreateModalCancel}
            width={350}
            okText="Create"
          >
            <label htmlFor="type">Type: </label>
            <Select
              value={createType}
              onChange={(value) => setCreateType(value)}
              className="w-100 mb-3"
            >
              <Option value="categories">Category</Option>
              <Option value="subcategories">Subcategory</Option>
              <Option value="units">Unit</Option>
              <Option value="locations">Location</Option>
            </Select>
            <label htmlFor="type">Name: </label>
            <Input
              value={createName}
              onChange={(e) => setCreateName(e.target.value)}
              placeholder="Enter name"
            />
          </Modal>
        </div>
      )}
    </div>
  );
}
